import { render, staticRenderFns } from "./TripAddButton.vue?vue&type=template&id=1f0cf07b&"
import script from "./TripAddButton.vue?vue&type=script&lang=js&"
export * from "./TripAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports